import { render, staticRenderFns } from "./TwoFactorDashboard.vue?vue&type=template&id=9000b602&scoped=true&"
import script from "./TwoFactorDashboard.vue?vue&type=script&lang=js&"
export * from "./TwoFactorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorDashboard.vue?vue&type=style&index=0&id=9000b602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9000b602",
  null
  
)

export default component.exports